import {COMMON_ROUTER} from "../constants";

const menuList = [
  {
    title: '订单',
    key: COMMON_ROUTER + '/order'
  },

  // {
  //   title: '配送管理',
  //   key: COMMON_ROUTER + '/deliveryManage'
  // },
  {
    title: '商品管理',
    key: COMMON_ROUTER + '/goods'
  },
  {
    title: '营业账单',
    key: COMMON_ROUTER + '/finance'
  },
  {
    title: '财务对账',
    key: COMMON_ROUTER + '/collection'
  },
  // {
  //   title: '店信息',
  //   key: COMMON_ROUTER + '/shopMessage'
  // },
];
export default menuList;



// WEBPACK FOOTER //
// ./src/config/menuConfig.js